import './Header.css'

export default function Header() {

    return <header>
        <div className="header"> 

            <img className = "header-logo-small" src={require("../images/logo.png")} />

            <div className="header-site-title">
                John Fahrenhorst
            </div>

        </div>

    </header>

}